const LOAD_CAPABILITIES = "LOAD_CAPABILITIES"
const LOADED_CAPABILITIES = "LOADED_CAPABILITIES"

export { LOAD_CAPABILITIES, LOADED_CAPABILITIES }
